/** @format */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { HttpService } from '@shared/data-access/services';
import { Title } from '@angular/platform-browser';
import { chain } from '@core/chain';

@Component({
	selector: 'plp-components-not-found',
	imports: [CommonModule, HmfTextLinkComponent],
	templateUrl: './not-found.component.html',
	styleUrl: './not-found.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent implements OnInit {
	constructor(
		private readonly title: Title,
		private readonly httpService: HttpService
	) {}

	ngOnInit(): void {
		// Set the HTTP Status Code to 404
		this.httpService.setStatusCode(404);
		// Set page title
		this.title.setTitle(`Page Not Found | ${chain.chainName}`);
	}
}
